var _path, _path2, _path3, _path4, _ellipse, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6529 2L1 6.58738V18.8714L11.6529 14.182V2Z",
    fill: "url(#paint0_linear_2808_95551)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.601 2L22.2539 6.58738V18.8714L11.601 14.182V2Z",
    fill: "url(#paint1_linear_2808_95551)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6529 14.1821L1 18.8714L11.2961 23.0001L22.2039 18.8714L11.6529 14.1821Z",
    fill: "url(#paint2_linear_2808_95551)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3555 8.32031V15.4077L18.4331 17.1892V10.1793L14.3555 8.32031Z",
    fill: "url(#paint3_linear_2808_95551)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.7709,
    cy: 13.5164,
    rx: 0.305825,
    ry: 0.203883,
    transform: "rotate(21.7622 17.7709 13.5164)",
    fill: "#FFF4DE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95703 14.2331C3.97402 12.7719 3.99781 9.74763 3.95703 9.33986L8.59538 7.30103V12.0413L3.95703 14.2331Z",
    fill: "#C9F7FF",
    stroke: "#C8C8C8",
    strokeWidth: 0.305825
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35096 8.47339L5.63736 8.77921L4.41406 13.8253L5.28057 13.4685L6.35096 8.47339Z",
    fill: "url(#paint4_linear_2808_95551)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42127 8.01465L6.70768 8.32047L5.48438 13.3666L6.35088 13.0098L7.42127 8.01465Z",
    fill: "url(#paint5_linear_2808_95551)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2808_95551",
    x1: 6.32646,
    y1: 2,
    x2: 6.32646,
    y2: 18.8714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DDF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1CDE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2808_95551",
    x1: 16.9274,
    y1: 2,
    x2: 16.9274,
    y2: 18.8714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2DFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2808_95551",
    x1: 6.86165,
    y1: 14.2331,
    x2: 17.6165,
    y2: 21.6239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5CE85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2808_95551",
    x1: 16.3943,
    y1: 8.32031,
    x2: 16.3943,
    y2: 17.1892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98259"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#976040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2808_95551",
    x1: 5.38251,
    y1: 8.47339,
    x2: 5.38251,
    y2: 13.8253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2808_95551",
    x1: 6.45282,
    y1: 8.01465,
    x2: 6.45282,
    y2: 13.3666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoom);
export default __webpack_public_path__ + "static/media/room.7167c33d1ab90e974d8755ea9756850b.svg";
export { ForwardRef as ReactComponent };